export enum Countries {
  CA = 'ca',
  US = 'us',
  JP = 'jp',
  VN = 'vn',
  AU = 'au',
  PH = 'ph',
  SG = 'sg',
  MY = 'my',
  ID = 'id',
  TH = 'th',
  IN = 'in',
  SE = 'se',
  UK = 'uk',
  DE = 'de',
  DK = 'dk',
  FR = 'fr',
  ES = 'es',
  IT = 'it',
  AT = 'at',
  FI = 'fi',
  GR = 'gr',
  PT = 'pt',
  BE = 'be',
  NL = 'nl',
  LV = 'lv',
  PL = 'pl',
  EE = 'ee',
  SI = 'si',
  HU = 'hu',
  CZ = 'cz',
  SK = 'sk',
  LT = 'lt',
  HR = 'hr',
  LU = 'lu',
  RO = 'ro',
  IE = 'ie',
  BG = 'bg',
  KR = 'kr',
}

export enum OLD_PRODUCTION_MINOR_COUNTRIES {
  AT = 'en_AT',
  FI = 'en_FI',
  GR = 'en_GR',
  PT = 'en_PT',
  LV = 'en_LV',
  PL = 'en_PL',
  EE = 'en_EE',
  HU = 'en_HU',
  CZ = 'en_CZ',
  SK = 'en_SK',
  LT = 'en_LT',
  HR = 'en_HR',
  LU = 'en_LU',
  RO = 'en_RO',
  IE = 'en_IE',
  BG = 'en_BG',
  SI = 'en_SI',
}

export enum Languages {
  EN = 'en',
  FR = 'fr',
  JA = 'ja',
  VI = 'vi',
  ID = 'id',
  TH = 'th',
  NL = 'nl',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  GR = 'gr',
  LU = 'lb',
  PL = 'pl',
  PT = 'pt',
  SK = 'sk',
  LV = 'lv',
  HU = 'hu',
  RO = 'ro',
  HR = 'hr',
  KO = 'ko',
}

export enum BRAND_LIST {
  UQ = 'uq',
  PL = 'pl',
  GU = 'gu',
}

export enum DistanceUnit {
  KM = 'km',
  MILE = 'mile',
}

export enum FeatureFlagKeys {
  STABLE_LOCALISATION_VERSION = 'slv',
  SEARCH_PAGE_SIZE = 'sl_sps',
}

export type FeatureFlags = {
  [key in FeatureFlagKeys]: FeatureFlagValue
}

export type FeatureFlagValue = string | number | boolean

// please refer showCountryLanguageSwitcher country config in EC-SPA for understanding
// importing only necesssay Bitmasking status
export enum CountryLanguageSwitcher {
  ALL_DISABLED = 0, // 00000 -> 0
  HEADER_SWITCHER_DISABLED = 1 << 0, // 00001 -> 1
  HEADER_SWITCHER_MODAL = 1 << 1, // 00010 -> 2
}
